The array of questionnaire components in the order they are presented to the candidate.
